import React from "react";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";

import Picture from "./Picture";
import ProfileDialog from "../Profiles/ProfileDialog";

import { getProfileImage, getProfileTypeIcon } from "../../utils/profile";

import colors from "../../assets/style/colors";

const ProfilePictureAndLink = (props) => {
  const { profile } = props;

  const profileImage = getProfileImage({
    images: get(profile, ["images"]),
    type: { id: get(profile, ["type", "id"]) },
  });

  return (
    <Grid container alignItems="center" wrap="nowrap">
      <Grid
        item
        className="flexCenter"
        style={{
          minWidth: "40px",
          justifyContent: "center",
          height: "40px",
          borderRadius: "4px",
          marginRight: "10px",
          backgroundColor: !profileImage ? colors.mediumGrey : "",
        }}
      >
        {profileImage ? (
          <Picture
            url={profileImage}
            maxHeight={40}
            alt="profile_image"
            style={{
              maxWidth: props.maxWidth || "80px",
              maxHeight: props.maxHeight || "40px",
              borderRadius: "4px",
            }}
          />
        ) : (
          <img
            src={getProfileTypeIcon(get(profile, ["type", "id"]))}
            style={{ maxWidth: "30px", maxHeight: "25px" }}
            alt="profile_icon"
          />
        )}
      </Grid>
      <Grid item>
        {props.noLink ? (
          <span className="text-54">{get(profile, ["name"])}</span>
        ) : (
          <ProfileDialog
            profileId={get(profile, ["id"])}
            name={get(profile, ["name"])}
            blockLevel2={true}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default ProfilePictureAndLink;
